import React, { Fragment, useState } from "react";

import ContactUs from "../../new-components/contact-us";
import SendUsMessages from "../../new-components/form/send-us-message/index";
import CanvasSection from "./canvasSection/canvasSection";
import AskedQuestions from "../../new-components/asked-questions";
import { CanvasClients } from "./canvas-clients";
import Calculator from "../../new-components/templates/calculator/calculator";

import CanvasPaint from "../../images/canvas-paint.jpg";
import CanvasImage1 from "../../images/Canvas-1.jpg";
import CanvasImage2 from "../../images/Canvas-2.jpg";
import CanvasImage3 from "../../images/Canvas-3.jpg";
import CanvasImage4 from "../../images/Canvas-4.jpg";

/* eslint import/no-webpack-loader-syntax: off */
import CanvasDecor1 from "-!svg-react-loader!../../../src/icons/canvas-decor-1.svg";
import CanvasDecor2 from "-!svg-react-loader!../../../src/icons/canvas-decor-2.svg";

import "./style.css";

const CanvasNew = () => {
  const [calculatorValues, setCalculatorValues] = useState({
    height: "",
    width: "",
    totalPrice: 0,
  });
  const scrollToElement = () => {
    const elem = document.getElementById("calculator-canvas");
    if (elem) {
      elem.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    }
  };
  const handleSendButtonClick = (height, width, totalPrice) => {
    setCalculatorValues({ height, width, totalPrice });
  };
  return (
    <Fragment>
      <CanvasSection>
        <div className="canvas__hero--wrapper">
          <div className="canvas__hero__content">
            <h1>Canvas Stretching in Singapore</h1>
            <p>
              Experienced providers of canvas stretching in Singapore for
              individuals and companies alike. Get a canvas stretching quote
              online or get in touch for any additional help.
            </p>
            <button
              className="canvas__hero__btn"
              onClick={scrollToElement}
              type="button"
            >
              Get a Quote
            </button>
          </div>
          <div className="canvas__hero__image">
            <div className="canvas__hero__image--wrap">
              <div className="canvas__hero__decor--left-top">
                <CanvasDecor1 />
              </div>
              <div className="canvas__hero__decor--right-top">
                <CanvasDecor2 />
              </div>
              <div className="canvas__hero__decor--left-down">
                <CanvasDecor2 />
              </div>
              <div className="canvas__hero__decor--right-down">
                <CanvasDecor1 />
              </div>
              <img src={CanvasPaint} alt="painting"></img>
            </div>
          </div>
        </div>
      </CanvasSection>
      <CanvasSection>
        <h2 className="about-us__title about-us__clients__title">
          Some of our clients
        </h2>
        <div className="about-us-clients__wrap">
          <ul className="about-us-clients__list">
            {CanvasClients.map((client) => (
              <li className="about-us-clients__item" key={client.id}>
                <div className="about-us-clients__image--wrapper">
                  <img src={client.src} alt={client.alt}></img>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </CanvasSection>
      <section className="canvas-section--grey" id="calculator-canvas">
        <div className="container">
          <Calculator onSendButtonClick={handleSendButtonClick} />
        </div>
      </section>
      <CanvasSection className="canvas__photo">
        <div className="canvas__photos--wrapper">
          <div className="canvas__photo--wrap">
            <img
              className="canvas__photo"
              src={CanvasImage1}
              alt="canvas photo"
            ></img>
          </div>
          <div className="canvas__photo--wrap">
            <img
              className="canvas__photo"
              src={CanvasImage2}
              alt="canvas photo"
            ></img>
          </div>
          <div className="canvas__photo--wrap">
            <img
              className="canvas__photo"
              src={CanvasImage4}
              alt="canvas photo"
            ></img>
          </div>
          <div className="canvas__photo--wrap">
            <img
              className="canvas__photo"
              src={CanvasImage3}
              alt="canvas photo"
            ></img>
          </div>
        </div>
      </CanvasSection>
      <CanvasSection>
        <AskedQuestions />
      </CanvasSection>
      <CanvasSection>
        <div className="about-us__form--wrap">
          <ContactUs />
          <div className="about-us__form__message--wrap">
            <SendUsMessages calculatorValues={calculatorValues} />
          </div>
        </div>
      </CanvasSection>
    </Fragment>
  );
};

export default CanvasNew;



// WEBPACK FOOTER //
// ./src/page/canvas/index.js